var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.413 43.63c0-.36-.266-.652-.587-.652h-8.817c-.327 0-.589.292-.589.652v3.466h9.993V43.63",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.604 22.25H23.3v24.847h5.121v-1.36h-3.192V24.18h35.446v21.555H38.413v1.36h24.191V22.25",
    style: {
      fill: "#7e7f81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.403 33.883.23-.285c.184-.224.436-.363.703-.407a1.12 1.12 0 0 1 1.297.935c.052.311-.011.624-.227.888l-2.184 2.734c-.16.213-.13.51.084.678.105.09.25.12.38.099l.01-.002.008-.002 3.06-.496a.474.474 0 0 0 .398-.552.48.48 0 0 0-.554-.407l-1.84.298 1.393-1.744a2.096 2.096 0 0 0 .432-1.65 2.073 2.073 0 0 0-.76-1.305 2.106 2.106 0 0 0-1.65-.434 2.085 2.085 0 0 0-1.306.764l-.229.284a.486.486 0 0 0 .076.68c.213.17.511.14.679-.076m15.657-2.54.23-.287c.185-.225.438-.363.704-.406a1.1 1.1 0 0 1 .89.228c.225.183.362.43.407.706.051.31-.015.626-.227.889l-2.182 2.73a.487.487 0 0 0 .082.681c.103.09.25.119.38.099h.008l.009-.003 3.062-.497a.476.476 0 0 0 .398-.553.481.481 0 0 0-.554-.406l-1.843.299 1.394-1.745a2.11 2.11 0 0 0 .434-1.65 2.073 2.073 0 0 0-.762-1.304 2.116 2.116 0 0 0-1.652-.434 2.067 2.067 0 0 0-1.305.762l-.227.286a.483.483 0 0 0 .074.68.479.479 0 0 0 .68-.075m-7.98 3.344 1.229-.198.194 1.203a.494.494 0 0 0 .574.412.5.5 0 0 0 .413-.572l-.196-1.202 1.227-.2a.482.482 0 0 0-.152-.95l-1.23.199-.195-1.202a.499.499 0 1 0-.985.158l.194 1.204-1.227.197a.49.49 0 0 0-.398.554c.042.267.293.44.552.397",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.604 47.097H23.3V22.25h39.305Zm.704-27.455H22.596c-1.05 0-1.908.81-1.908 1.809v25.973h44.527V21.45c0-.998-.856-1.81-1.907-1.81",
    style: {
      fill: "#d3d4d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.648 33.28.229-.285a2.085 2.085 0 0 1 1.305-.764c.564-.091 1.17.05 1.65.434.425.33.682.813.761 1.305a2.096 2.096 0 0 1-.432 1.65l-1.394 1.744 1.841-.298a.48.48 0 0 1 .554.407.474.474 0 0 1-.397.552l-3.06.496-.009.002-.01.002a.468.468 0 0 1-.38-.1.484.484 0 0 1-.084-.677l2.184-2.733c.216-.265.279-.578.227-.89a1.124 1.124 0 0 0-.406-.705 1.113 1.113 0 0 0-.89-.23 1.153 1.153 0 0 0-.704.408l-.23.285a.474.474 0 0 1-.679.077.486.486 0 0 1-.076-.68zm8.278.456 1.227-.197-.194-1.204a.499.499 0 1 1 .985-.158l.195 1.202 1.23-.2a.482.482 0 0 1 .152.95l-1.227.2.196 1.203a.5.5 0 0 1-.413.572.494.494 0 0 1-.574-.412l-.194-1.203-1.23.198a.479.479 0 0 1-.551-.397.49.49 0 0 1 .398-.554zm7.38-2.998.227-.286c.33-.426.812-.683 1.305-.762a2.113 2.113 0 0 1 1.652.434c.425.33.682.812.762 1.304.09.562-.05 1.17-.434 1.65l-1.394 1.745 1.843-.3a.481.481 0 0 1 .554.407.476.476 0 0 1-.398.553l-3.063.497-.008.002h-.008a.472.472 0 0 1-.38-.098.487.487 0 0 1-.082-.68l2.182-2.731c.212-.263.278-.578.227-.89a1.136 1.136 0 0 0-.406-.705 1.107 1.107 0 0 0-.891-.228 1.155 1.155 0 0 0-.705.406l-.228.288a.479.479 0 0 1-.68.074.483.483 0 0 1-.075-.68zM25.228 45.736h3.192V43.63c0-.36.262-.652.59-.652h8.816c.321 0 .587.292.587.652v2.106h22.261V24.181H25.228v21.555",
    style: {
      fill: "#a8a9ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.683 47.424h-1.468v.473c0 .997-.856 1.808-1.907 1.808h3.375c.36 0 .653-.166.653-.371v-1.539c0-.205-.293-.371-.653-.371",
    style: {
      fill: "#a7a9ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.09 47.424H19.22c-.361 0-.653.166-.653.371v1.539c0 .205.292.371.654.371h44.087c1.051 0 1.907-.81 1.907-1.808v-.473H64.09",
    style: {
      fill: "#a7a9ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.313 68.763h-3.501V51.82h3.501v16.943m1.284 0h3.5V51.82h-3.5v16.943",
    style: {
      fill: "#6d6e71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.075 34.615v2.375H68.7v-2.375h-1.625",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.751 36.586h.002l-.134-.035s-1.3-.216-1.709-.296c-.062.135-.955.656-.955.656-.002 0-.947-.745-.947-.745-.409.078-1.807.385-1.807.385l-.136.035-1.972.53v14.688l9.634.017V39.772l.09-2.655-2.066-.53",
    style: {
      fill: "#b3d7e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.955 36.91 1.141 2.284.661-2.79-.847-.34-.955.847m0-.001-1.138 2.253-.687-2.814.87-.285.955.847",
    style: {
      fill: "#72bdc4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.96 38.91.815-.366-.82-1.633-.82 1.633.815.366v.004l.005-.001.005.001v-.004",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.955 37.79s-1.182 3.637-1.259 4.9c-.119 1.918.98 7.587 1.26 7.587.271 0 1.375-5.67 1.26-7.586-.08-1.264-1.26-4.902-1.26-4.902",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.87 69.291h-1.743V55.392h1.742v13.9m26.601-.001h1.743V55.392H56.47v13.9",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.158 58.157h-28.41v-4.033h28.41v4.033",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.213 56.14H28.127v-2.89h30.086v2.89",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.286 55.401h-9.43v-1.92h9.43v1.92",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.305 67.352c-.133-.339-2.826-.507-3.415-.1-.186.13-.29.982-.29.982h3.875s-.065-.615-.17-.882m.17 1.331H68.6v-.449h3.876v.45m-8.681-1.332c.133-.339 2.826-.507 3.415-.1.186.13.291.982.291.982h-3.876s.064-.615.17-.882m-.17 1.331H67.5v-.449h-3.876v.45",
    style: {
      fill: "#262626",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.294 30.387c0 2.577-2.399 4.728-5.406 4.728-3.008 0-5.447-2.087-5.447-4.663 0-2.575 2.25-6.288 5.259-6.288 3.008 0 5.594 3.648 5.594 6.223",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.733 29.535a.553.553 0 1 1-1.106 0 .553.553 0 0 1 1.106 0",
    style: {
      fill: "#525355",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.47 29.404a.229.229 0 1 1-.457 0 .229.229 0 0 1 .457 0",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.043 29.535a.552.552 0 1 0 1.104.002.552.552 0 0 0-1.104-.002",
    style: {
      fill: "#525355",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.305 29.404a.229.229 0 1 0 .457 0 .229.229 0 0 0-.457 0",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.473 31.467a.746.746 0 1 1-1.493-.002.746.746 0 0 1 1.493.002m8.828 0a.747.747 0 0 0 1.493 0 .746.746 0 0 0-1.493 0",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.013 28.08c-.52 0-.965.18-1.189.44 0 0 .557-.306 1.189-.306.66 0 1.187.306 1.187.306-.223-.26-.668-.44-1.187-.44m3.751 0c.519 0 .963.18 1.187.44 0 0-.555-.306-1.187-.306-.662 0-1.189.306-1.189.306.225-.26.67-.44 1.189-.44",
    style: {
      fill: "#525355",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.424 30.788s-.81-3.413-.139-4.244c4.448-5.518 11.372-1.191 11.372.309s-.367 3.909-.367 3.909-.644-1.827-1.106-2.682c-.569-1.053-.523-1.69-.523-1.69s-4.419 1.931-7.563.196c0 0 .056 2.87-1.674 4.202",
    style: {
      fill: "#262626",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.847 31.226a.154.154 0 0 1-.15.157.153.153 0 0 1-.148-.157c0-.086.066-.158.149-.158.081 0 .15.072.15.158m-.484.436c0 .061-.047.11-.106.11a.109.109 0 0 1-.106-.11c0-.063.048-.112.106-.112.06 0 .106.049.106.112m.106-.933a.108.108 0 0 1-.106.111.109.109 0 0 1-.106-.111c0-.062.047-.112.106-.112.06 0 .105.05.105.112m.859.111a.11.11 0 0 1-.106.112.11.11 0 0 1-.106-.112c0-.062.046-.111.106-.111a.11.11 0 0 1 .106.111m-.156.822c0 .061-.047.11-.104.11a.108.108 0 0 1-.107-.11c0-.063.047-.112.107-.112.057 0 .104.049.104.112m-.26-1.036c0 .039-.028.07-.065.07a.067.067 0 0 1-.066-.07c0-.038.029-.069.066-.069.037 0 .065.03.065.07m-.72.529c0 .038-.03.07-.067.07a.069.069 0 0 1-.067-.07c0-.04.03-.07.067-.07.038 0 .067.03.067.07m.488.686c0 .04-.029.071-.065.071-.037 0-.066-.032-.066-.07 0-.04.029-.07.066-.07.036 0 .066.03.066.07m.674-.547c0 .039-.03.07-.067.07a.067.067 0 0 1-.066-.07c0-.039.03-.07.066-.07.037 0 .067.031.067.07m5.489-.07c0 .087.066.157.148.157.084 0 .15-.07.15-.157a.154.154 0 0 0-.15-.158c-.082 0-.148.072-.148.158m.484.436c0 .061.046.11.105.11s.106-.049.106-.11a.108.108 0 0 0-.106-.112c-.059 0-.105.049-.105.112m-.108-.933a.11.11 0 0 0 .108.111c.058 0 .105-.05.105-.111 0-.062-.047-.112-.105-.112a.11.11 0 0 0-.108.112m-.857.111c0 .061.047.112.106.112a.11.11 0 0 0 .106-.112.11.11 0 0 0-.106-.111.108.108 0 0 0-.106.111m.155.822c0 .061.047.11.105.11.06 0 .107-.049.107-.11a.108.108 0 0 0-.107-.112c-.058 0-.105.049-.105.112m.259-1.036c0 .039.03.07.067.07a.068.068 0 0 0 .066-.07.068.068 0 0 0-.066-.069.068.068 0 0 0-.067.07m.723.529c0 .038.029.07.066.07.036 0 .065-.032.065-.07 0-.04-.029-.07-.065-.07a.068.068 0 0 0-.067.07m-.49.686c0 .04.029.071.067.071.037 0 .066-.032.066-.07 0-.04-.03-.07-.066-.07a.068.068 0 0 0-.067.07m-.673-.547c0 .039.03.07.067.07a.068.068 0 0 0 .066-.07c0-.039-.03-.07-.066-.07a.069.069 0 0 0-.067.07",
    style: {
      fill: "#fdcd85",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.57 38.278.063.103-.063-.103",
    style: {
      fill: "#145765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.585 46.368s.651-.807.556-1.363c0 0 .635-.174 1.068-.198 0 0-.898-.009-1.059.003 0 0 .189-.429.08-.709 0 0 1.244.073 2.18 0 .939-.071 2.902-1.063 3.545.667v1.147s-3.792-.633-6.37.453m12.742 0s-.653-.807-.556-1.363c0 0-.47-.175-.904-.199 0 0 .732-.008.894.004 0 0-.189-.429-.08-.709 0 0-1.245.073-2.18 0-.938-.071-2.902-1.063-3.546.667v1.147s3.792-.633 6.372.453",
    style: {
      fill: "#fbcb89",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.18 46.733s1.92 2.402 2.426 4.613l3.706-.38-.312-4.96-.822-.595s-4.662.625-4.997 1.323",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.97 46 .342 4.983s.26.137.643.178v-4.98c-.625 0-.985-.181-.985-.181m1.97 0-.341 4.983s-.26.137-.644.178v-4.98c.625 0 .985-.181.985-.181",
    style: {
      fill: "#b5441f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.97 45.543s-.312-.661-1.97-.373c-1.659.289-3.82 1.394-3.82 1.394v.169s2.573-1.098 4.516-.902c.83.084 1.303.174 1.303.174l-.03-.462",
    style: {
      fill: "#fab962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73 46.733s-1.92 2.402-2.426 4.613l-3.705-.38.313-4.961.821-.595s4.662.625 4.998 1.323",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94 45.543s.313-.661 1.97-.373c1.659.289 3.82 1.394 3.82 1.394v.169s-2.573-1.098-4.515-.902c-.83.084-1.303.174-1.303.174l.028-.462",
    style: {
      fill: "#fab962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.955 46.182v-.67s.878-.364 1.924-.402l.135.741s-.631.1-1.23.243c-.434.105-.829.088-.829.088",
    style: {
      fill: "#fab962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.955 46.182v-.67s-.877-.364-1.923-.402l-.136.741s.632.1 1.23.243c.436.105.83.088.83.088m-.001-1.072s.846-1.292 2.744-.54c0 0-1.435-.41-2.744.636v-.096m0 0s-.845-1.292-2.743-.54c0 0 1.435-.41 2.743.636v-.096",
    style: {
      fill: "#fab962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.96 50.918s1.598-1.36.261-2.679c0 0-1.799.48-.262 2.68",
    style: {
      fill: "#86a1aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.198 50.189s2.542 1.21 2.931.172c.416-1.11-.155-1.497-2.063-1.89-1.906-.39-.868 1.718-.868 1.718",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.698 48.54s1.37-.726 1.667-.505c.186.138.216.478-.496.695-.711.215-1.17-.19-1.17-.19",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.861 36.99-5.515 9.952 4.613 3.976s-.622-.91.262-2.679l-2.37-2.132 3.358-4.919V36.99h-.348",
    style: {
      fill: "#b3d7e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.952 50.918s-1.6-1.36-.263-2.679c0 0 1.8.48.263 2.68",
    style: {
      fill: "#86a1aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.713 50.189s-2.541 1.21-2.931.172c-.416-1.11.155-1.497 2.062-1.89 1.907-.39.869 1.718.869 1.718",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.213 48.54s-1.37-.726-1.667-.505c-.186.138-.216.478.495.695.712.215 1.172-.19 1.172-.19",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.05 36.99 5.514 9.952-4.612 3.976s.62-.91-.263-2.679l2.371-2.132-3.415-5.016-.235-4.101h.64",
    style: {
      fill: "#b3d7e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.645 32.957a.766.766 0 0 1-.777.753.766.766 0 0 1-.778-.753c0-.416.348-.754.778-.754.43 0 .777.338.777.754",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.455 52.89H65.27v-1.083h6.184v1.083",
    style: {
      fill: "#6d6e71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.371 29.785h-.91v-.291h.91v.291",
    style: {
      fill: "#373739",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 30.656a1.015 1.015 0 0 1-1.016-1.016c0-.096.018-.187.041-.273a1.01 1.01 0 0 1 1.946 0 .974.974 0 0 1 .042.273c0 .56-.454 1.016-1.014 1.016zm0-2.234c-.54 0-1.021.364-1.168.888-.035.12-.052.225-.052.33a1.22 1.22 0 0 0 1.22 1.218 1.22 1.22 0 0 0 1.217-1.218c0-.105-.017-.21-.05-.33a1.22 1.22 0 0 0-1.168-.888m3.138 2.234a1.016 1.016 0 0 1-1.015-1.016c0-.096.018-.187.042-.273a1.01 1.01 0 0 1 1.946 0c.024.086.041.177.041.273 0 .56-.455 1.016-1.014 1.016zm1.168-1.346a1.218 1.218 0 0 0-1.168-.888c-.54 0-1.02.364-1.169.887a1.23 1.23 0 0 0-.05.331 1.22 1.22 0 0 0 1.22 1.218 1.22 1.22 0 0 0 1.217-1.218c0-.105-.016-.21-.05-.33",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    transform: "translate(-19.885 -29.275) scale(1.49046)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher1);
export default __webpack_public_path__ + "static/media/teacher1.d82fad8c063f3651d2655aa6d0dbcfe0.svg";
export { ForwardRef as ReactComponent };